<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 108px);"
      >
        <div class="contact"
          @scroll="handleScroll"
        >
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link current">お問い合わせ</span> ／ <span class="breadcrumb-link">お問い合わせ内容の確認</span> ／ <span class="breadcrumb-link">お問い合わせ受付の完了</span>
            </div>
            <h1 class="hdg02">お問い合わせ</h1>
          </div>
          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt mb20">以下に必要事項を入力してお問い合わせください。</p>
              <p class="txt" :class="group1.isError ? 'mb20' : 'mb40'">コンテンツの内容に関するお問い合わせについて<br>
                書籍名などコンテンツの該当箇所、ご質問内容をご明示ください。<br>
                なお、法令条文の解釈や法律相談、個別事例等にはお答えできません。また、お問い合わせ内容によって、お答えに時間をいただく場合がございます。
              </p>
              <p class="error-message mb40" v-if="group1.isError">入力内容に不備があるようです。下記メッセージ（赤文字）のご確認をお願いいたします。</p>

              <h2 class="hdg03 mb28">お問い合わせフォーム</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th class="border-none">
                          <span class="contact-content-table-hdg">お問い合わせ内容 <span class="txt-red">[必須]</span></span>
                        </th>
                        <td class="border-none">
                          <div class="formparts select" style="max-width:480px;"
                            @mouseenter="group1.isVisibleTypeList = true"
                            @mouseleave="group1.isVisibleTypeList = false"
                            :class="{'is-visible-list': group1.isVisibleTypeList}"
                            >
                            <div class="select-label" role="select">{{ group1.message_type || '選択してください' }}<FontawesomeIcon icon="angle-down" class="icn" /></div>
                            <div class="select-option">
                              <ul class="select-option-list">
                                <li role="option"
                                  v-for="item in group1.listTypeItem" :key="'type_' + item.value"
                                  >
                                  <label><input type="radio" :value="item.value" v-model="group1.currentTypeValue" name="group_rd_02"
                                    @click="group1.onTypeListSelected(item.label)">{{ item.label }}</label>
                                </li>
                              </ul>
                            </div>
                            <p class="error-message" v-if="group1.error_message_type">{{group1.error_message_type}}</p>
                          </div>
                          <div class="formparts textarea">
                            <textarea v-model="group1.message" rows="5" placeholder="お問い合わせ内容をご入力ください。"></textarea>
                            <p class="error-message" v-if="group1.error_message">{{group1.error_message}}</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
              
              <div class="contact-submit">
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.submitButtonClicked">次へ</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import * as logicLoggedinInquiry from '@/logic/inquiry/LoggedinInquiry.js'

export default defineComponent({
  components: {
    PCMenu
  },
  beforeRouteEnter (to, from, next) {
    if (from.name !== 'PCInquiryConfirm') {
      // 確認画面以外から遷移して来た場合はストアに保持している値を全クリア
      store.dispatch('inquiry/clearAllStates')
    }
    next()
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicLoggedinInquiry.getGroupIndex()

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.breadcrumb {
  color: $color-content;
  font-size: 1.4rem;
  margin-bottom: 16px;
  &-link {
    color: $color-inactive;
    &.current {
      color: $color-content;
    }
  }
}
.contact {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0;
    .button .btn[type="submit"] {
      width: 230px;
      margin: 32px auto 0;
    }
  }
  &-head {
    padding: 40px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    &-list {
      list-style: none;
      margin-bottom: 32px;
      &-item {
        border-top: 1px solid $color-line;
        padding: 32px 0;
      }
      .contact-content-table {
        th,td {
          padding: 0 20px;
        }
      }
    }
    &-table {
      width: 100%;
      border-collapse: collapse;
      .border-none {
        border: 0!important;
      }
      &.border-bottom {
        border-bottom: 1px solid $color-line;
      }
      thead {
        th {
          color: $color-sup;
          font-size: 1.6rem;
          font-weight: normal;
          padding: 16px 20px;
        }
      }
      tbody {
        // th {
        //   vertical-align: baseline;
        // }
        th,td {
          padding: 16px 20px;
          border-top: 1px solid $color-line;
          vertical-align: baseline;
        }
      }
      &-hdg {
        display: block;
        color: $color-hdg;
        font-size: 1.6rem;
        font-weight: bold;
        &.is-inactive {
          color: $color-inactive;
        }
      }
      &-sup {
        color: $color-sup;
        font-size: 1.4rem;
      }
      &-btnarea {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .contact-content-table-link {
          margin-left: 20px;
        }
      }
      &-btn {
        width: 160px;
        .formparts.select .select-label,
        .button .btn {
          height: 32px;
        }
      }
      &-link {
        font-size: 1.6rem;
        color: $color-link;
      }
      // &-list {
      //   li {
      //     padding-left: 10px;
      //   }
      //   .checkbox {
      //     padding: 12px 0;
      //   }
      //   .textarea {
      //     textarea {
      //       width: 100%;
      //     }
      //   }
      //   &-parts {
      //     display: flex;
      //     align-items: center;
      //     padding: 12px 0 12px 30px;
      //     .txt,
      //     .select {
      //       display: inline-block;
      //       margin-right: 12px;
      //       margin-bottom: 0;
      //     }
      //     .select-label {
      //       height: 32px;
      //     }
      //   }
      // }
    }
  }
  &-submit {
    width: 230px;
    margin: 32px auto 200px;
  }
}
.list-inline {
  a {
    @include hoverOpacity;
  }
}
.footer {
  margin-top: 72px;
  margin-bottom: 40px;
  text-align: center;
  a {
    font-size: 1.2rem;
  }
}
</style>
